if(!customElements.get('event-builder')) {
    class EventBuilder extends HTMLElement {
      constructor() {
        super();
        this.builder = this.closest('product-main-builder');
        this.datePicker = this.querySelector('[type="date"]');
        this.eventDatePicker = this.querySelector('.event-picker[type="date"]');
        this.eventTypeSelector = this.querySelector('select');
        const eventDataElement = this.querySelector('[type="application/json"][data-event-builder-json]');
        this.eventData = eventDataElement ? JSON.parse(eventDataElement.textContent) : {};
        this.monthlyTurnaroundsMap = this.eventData.monthly_turnarounds || {};
        if(this.eventData.blooms_box_availability_messages){
          this.bloomsBoxAvailabilityMap = this.eventData.blooms_box_availability_messages.map((item)=>{
            const splited = item.split(':');
            return {
              days: parseInt(splited[0]),
              message: splited[1],
              title: splited[2]
            }
          });
        }
        this.bloomsBoxAvailabilityDays = this.eventData.blooms_box_availability;
        this.messageTurnaround = this.querySelector('.message-turnaround')
        this.messageBlooms = this.querySelector('.message-blooms') || document.querySelector('.custom-card-event .message-blooms');
        this.messageInput = this.querySelector('.turnaround-estimate');
        this.bloomsSelector = this.querySelectorAll('[name="bloom_box"]');
        this.bloomProductInputs = this.querySelectorAll('.bloom-product input[type="hidden"]');
        this.shippingLabelSelector = this.querySelectorAll('[name="shipping_label"]');
        this.shippingLabelProductInputs = this.querySelectorAll('.shipping-label-product input[type="hidden"]');
        this.bloomsBoxAvailable = false;
        this.openBloomBoxLearnMore = this.querySelector('.open-bloom-box-popup');
        this.preventBuy = this.dataset.preventBuy=='true';
        this.addToCartButton = this.closest('.product-main-element')?.querySelector('.btn.add');
        this.zipCodeInput = this.querySelector('.zip-code-input');
        this.locationResults = this.querySelector('.location-results');
        this.locationResultsTitle = this.querySelector('.shipping-header-row');
        this.nearPickupLocation = false;
        this.zipCodeEntered = false;
        this.currentZipCode = null;
        this.isProcessingZipCode = false;

        // Pickup site mode settings
        this.pickupSiteMode = this.eventData.pickup_site_mode || false;
        this.useGeolocation = this.eventData.use_geolocation || false;
        this.pickupRadiusMiles = this.eventData.pickup_radius_miles || 50;
        this.userCoordinates = null;

        if(this.addToCartButton && this.preventBuy){
          this.addToCartButton.setAttribute('disabled', 'disabled');
        }

        if(this.openBloomBoxLearnMore){
          this.openBloomBoxLearnMore.addEventListener('click', (e)=>{
            const href = new URL(e.target.href);

            if(href.hash){
              e.preventDefault();
              const popup = document.querySelector(href.hash);
              
              if(popup){
                let popupSectionClone = popup.closest('.shopify-section').cloneNode(true);
                popupSectionClone.insertAdjacentHTML('beforeend', popup.innerHTML);
                $s.openModal(popupSectionClone, 'product-quick-view');
                $s.globalEval(popupSectionClone);
              }
            }
          })
        }

        // Skip date picker initialization in pickup site mode
        if (!this.pickupSiteMode) {
          if (this.eventDatePicker) {
            this.eventDatePicker.addEventListener('change', this.onEventDateChange.bind(this));
            const today = new Date().toISOString().split('T')[0];
            this.eventDatePicker.value = today;
            this.eventDatePicker.dispatchEvent(new Event('change'));
            const dateIcon = this.querySelector('.custom-date-icon');
            if (dateIcon) {
              dateIcon.addEventListener('click', () => {
                this.eventDatePicker.showPicker(); // Opens the native date picker
              });
            }
          } else if (this.datePicker) {
            this.datePicker.addEventListener('change', this.onDateChange.bind(this));
          }
        }

        if(this.eventTypeSelector) {
            this.eventTypeSelector.addEventListener('change', this.onEventTypeChange.bind(this));
        }
  
        if(this.bloomsSelector.length > 0) {
          this.bloomsSelector.forEach((selector)=>{
            selector.addEventListener('change', this.onBloomsSelectorChange.bind(this));
          });
        }

        if(this.shippingLabelSelector.length > 0) {
          this.shippingLabelSelector.forEach((selector)=>{
            selector.addEventListener('change', this.onShippingLabelSelectorChange.bind(this));
          });
        }

        if(this.zipCodeInput) {
          this.zipCodeInput.style.zIndex = '1';
          this.zipCodeInput.style.position = 'relative';
          this.hideZipCodeInput();
          this.zipCodeInput.addEventListener('keypress', (e) => {
            if (e.key === 'Enter') {
              this.onZipCodeSearch(e);
            }
          });

          if(this.zipCodeInput) {
            this.zipCodeInput.addEventListener('blur', this.onZipCodeBlur.bind(this));
          }
          if(this.zipCodeInput) {
            this.zipCodeInput.addEventListener('focus', (e) => {
            });
            this.zipCodeInput.addEventListener('click', (e) => {
              e.stopPropagation();
            });
          }
          // Auto-search on mobile only when user types 5 digits
          const isMobile = window.matchMedia('(max-width: 768px)').matches;
          if (isMobile && this.zipCodeInput) {
            this.zipCodeInput.addEventListener('input', (e) => {
              const zipCode = e.target.value.trim();
              if (zipCode.length === 5 && /^\d{5}$/.test(zipCode)) {
                // Small delay to avoid rapid-fire calls while typing
                setTimeout(() => {
                  if (e.target.value.trim() === zipCode) {
                    this.onZipCodeSearch(e);
                  }
                }, 300);
              }
            });
          }
          setTimeout(() => {
            const btn = this.querySelector('.zip-search-btn');
          }, 1000);
          this.addEventListener('click', (e) => {
            if (e.target.closest('.zip-search-btn')) {
              e.preventDefault();
              this.onZipCodeSearch(e);
            }
          });

          // Also try document-level delegation as backup
          document.addEventListener('click', (e) => {
            if (e.target.closest('.zip-search-btn')) {
              e.preventDefault();
              this.onZipCodeSearch(e);
            }
          });
        }

        // Add event delegation for dynamically added buttons
        if(this.locationResults) {
          this.locationResults.addEventListener('click', this.onLocationResultsClick.bind(this));
          
          // Add event delegation for modal links too
          this.locationResults.addEventListener('click', (e) => {
            if(e.target.tagName === 'A' && e.target.href.includes('#open-info-modal')) {
              e.preventDefault();
              this.handleLinkClick(e);
            }
          });
        }

        // update data price from bloom-product for ab testing using the localstorage from ABConvert
        if(localStorage){
          const dataTesting = JSON.parse(localStorage.getItem('abconvert-price-cart-transform-test-dict'));
          const bloomboxProductElement = this.querySelector('.bloom-product');
          if(dataTesting && bloomboxProductElement){
            const bloomboxProductId = bloomboxProductElement.dataset.productId;
            const dataTestingProduct = dataTesting[bloomboxProductId];

            if(dataTestingProduct){
              bloomboxProductElement.dataset.price = dataTestingProduct.allLowestPrice*100;
            }
          }
        }

        // Initialize pickup site mode if enabled
        if (this.pickupSiteMode) {
          this.initPickupSiteMode();
        }

      }

      // Pickup Site Mode Methods
      initPickupSiteMode() {
        // Hide the entire step container and all event-related elements
        const stepContainer = this.querySelector('.step');
        if (stepContainer) {
          stepContainer.innerHTML = '';
        }

        // Hide any turnaround/blooms messaging
        if (this.messageTurnaround) this.messageTurnaround.style.display = 'none';
        if (this.messageBlooms) this.messageBlooms.style.display = 'none';

        // Hide the "Recommended Shipping" section (blooms section)
        const bloomsSection = this.querySelector('.blooms');
        if (bloomsSection) {
          bloomsSection.closest('.step')?.style.setProperty('display', 'none');
        }
        // Also try to find it as a sibling
        const parentModule = this.closest('.module');
        if (parentModule) {
          const nextStep = parentModule.nextElementSibling;
          if (nextStep && nextStep.querySelector('.blooms')) {
            nextStep.style.display = 'none';
          }
        }

        // Disable event listeners that would trigger API calls
        if (this.eventDatePicker) {
          this.eventDatePicker.removeEventListener('change', this.onEventDateChange);
        }
        if (this.datePicker) {
          this.datePicker.removeEventListener('change', this.onDateChange);
        }

        // Find add to cart button more broadly
        const productMain = this.closest('.product-main-element') || document.querySelector('.product-main-element');
        if (productMain) {
          this.addToCartButton = productMain.querySelector('.btn.add') ||
                                  productMain.querySelector('button[type="submit"]') ||
                                  productMain.querySelector('[data-add-to-cart]') ||
                                  document.querySelector('form[action*="/cart/add"] button[type="submit"]');
        }

        // Show the location finder UI
        this.showPickupSiteUI();

        // If geolocation is enabled, prompt for location
        if (this.useGeolocation) {
          this.promptForGeolocation();
        }
      }

      showPickupSiteUI() {
        const stepContainer = this.querySelector('.step') || this;
        const description = this.eventData.pickup_site_description || '<p>Enter your zip code or allow location access to find pickup locations near you.</p>';
        const title = this.eventData.pickup_site_title || 'Find a pickup location';

        // Build the complete pickup site UI
        stepContainer.innerHTML = `
          <div class="option-title">${title}</div>
          <div class="pickup-site-container" style="padding: 1rem 0;">
            <div class="pickup-site-intro" style="text-align: center; margin-bottom: 1.5rem;">
              ${description}
            </div>
            ${this.useGeolocation ? `
            <div class="geolocation-prompt" style="text-align: center; margin-bottom: 1.5rem;">
              <button type="button" class="btn use-my-location" style="margin-bottom: 0.5rem;">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="margin-right: 0.5rem; vertical-align: middle;">
                  <circle cx="12" cy="12" r="10"></circle>
                  <circle cx="12" cy="12" r="3"></circle>
                  <line x1="12" y1="2" x2="12" y2="6"></line>
                  <line x1="12" y1="18" x2="12" y2="22"></line>
                  <line x1="2" y1="12" x2="6" y2="12"></line>
                  <line x1="18" y1="12" x2="22" y2="12"></line>
                </svg>
                Use My Location
              </button>
              <div style="color: #666; font-size: 0.9rem;">or enter your zip code below</div>
            </div>
            ` : ''}
            <div class="zip-code-section" style="display: flex; justify-content: center; align-items: center; margin-bottom: 1.5rem;">
              <div style="display: flex; align-items: center;">
                <input type="text" class="zip-code-input" placeholder="Enter zip code" maxlength="5" pattern="[0-9]*" inputmode="numeric" style="
                  padding: 0.75rem 0.5rem;
                  font-size: 1.3rem;
                  border: none;
                  border-bottom: 1px solid var(--scheme-borders-color, #ddd);
                  border-radius: 0;
                  background: transparent;
                  text-align: center;
                  width: 180px;
                  outline: none;
                ">
                <button type="button" class="zip-search-btn" aria-label="Search zip code" style="
                  background: none;
                  border: none;
                  cursor: pointer;
                  padding: 8px;
                  color: #666;
                  transition: color 0.2s ease;
                ">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <circle cx="11" cy="11" r="8"></circle>
                    <path d="m21 21-4.35-4.35"></path>
                  </svg>
                  <div class="zip-loading-spinner" style="display: none; width: 20px; height: 20px; border: 2px solid #f3f3f3; border-top: 2px solid #666; border-radius: 50%; animation: spin 1s linear infinite;"></div>
                </button>
              </div>
            </div>
            <div class="location-results" style="display: block;">
              <div class="pickup-locations-list" style="display: none;"></div>
            </div>
          </div>
        `;

        // Update references to new elements
        this.zipCodeInput = stepContainer.querySelector('.zip-code-input');
        this.locationResults = stepContainer.querySelector('.location-results');

        // Add event listener for geolocation button
        const geoButton = stepContainer.querySelector('.use-my-location');
        if (geoButton) {
          geoButton.addEventListener('click', () => this.requestGeolocation());
        }

        // Add zip code input listeners
        if (this.zipCodeInput) {
          this.zipCodeInput.addEventListener('keypress', (e) => {
            if (e.key === 'Enter') {
              this.onZipCodeSearch(e);
            }
          });
        }

        // Add search button listener
        const searchBtn = stepContainer.querySelector('.zip-search-btn');
        if (searchBtn) {
          searchBtn.addEventListener('click', (e) => this.onZipCodeSearch(e));
        }
      }

      promptForGeolocation() {
        // Check if geolocation is available
        if (!navigator.geolocation) {
          console.log('Geolocation not available');
          return;
        }

        // Check permission state if available
        if (navigator.permissions) {
          navigator.permissions.query({ name: 'geolocation' }).then((result) => {
            if (result.state === 'granted') {
              // Already granted, get location automatically
              this.requestGeolocation();
            }
            // If 'prompt' or 'denied', wait for user to click button
          });
        }
      }

      requestGeolocation() {
        if (!navigator.geolocation) {
          alert('Geolocation is not supported by your browser');
          return;
        }

        const geoButton = this.locationResults?.querySelector('.use-my-location');
        if (geoButton) {
          geoButton.disabled = true;
          geoButton.innerHTML = `
            <span class="loading-spinner" style="display: inline-block; width: 16px; height: 16px; border: 2px solid #ccc; border-top-color: #333; border-radius: 50%; animation: spin 1s linear infinite; margin-right: 0.5rem; vertical-align: middle;"></span>
            Getting location...
          `;
        }

        navigator.geolocation.getCurrentPosition(
          (position) => {
            this.userCoordinates = {
              lat: position.coords.latitude,
              lng: position.coords.longitude
            };
            this.findAllNearbyLocations(this.userCoordinates.lat, this.userCoordinates.lng);
          },
          (error) => {
            console.log('Geolocation error:', error.message);
            if (geoButton) {
              geoButton.disabled = false;
              geoButton.innerHTML = `
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="margin-right: 0.5rem; vertical-align: middle;">
                  <circle cx="12" cy="12" r="10"></circle>
                  <circle cx="12" cy="12" r="3"></circle>
                  <line x1="12" y1="2" x2="12" y2="6"></line>
                  <line x1="12" y1="18" x2="12" y2="22"></line>
                  <line x1="2" y1="12" x2="6" y2="12"></line>
                  <line x1="18" y1="12" x2="22" y2="12"></line>
                </svg>
                Use My Location
              `;
            }
            // Show message to use zip code instead
            const geoPrompt = this.locationResults?.querySelector('.geolocation-prompt');
            if (geoPrompt) {
              geoPrompt.innerHTML += `<div style="color: #c00; font-size: 0.9rem; margin-top: 0.5rem;">Could not get your location. Please enter your zip code.</div>`;
            }
          },
          {
            enableHighAccuracy: true,
            timeout: 10000,
            maximumAge: 300000 // 5 minutes
          }
        );
      }

      async findAllNearbyLocations(lat, lng) {
        // Show loading state for pickup site mode
        const locationsList = this.locationResults?.querySelector('.pickup-locations-list');
        if (locationsList) {
          locationsList.innerHTML = `
            <div style="text-align: center; padding: 2rem;">
              <div class="loading-spinner" style="display: inline-block; width: 24px; height: 24px; border: 3px solid #ccc; border-top-color: #333; border-radius: 50%; animation: spin 1s linear infinite;"></div>
              <div style="margin-top: 0.5rem; color: #666;">Finding nearby locations...</div>
            </div>
          `;
          locationsList.style.display = 'block';
        }

        try {
          // Query all locations within the radius with inventory check
          const response = await fetch(`https://pf-shopify-locations-api.netlify.app/.netlify/functions/locations?lat=${lat}&lng=${lng}&inventory=true&radius=${this.pickupRadiusMiles}`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json'
            }
          });

          const result = await response.json();

          if (result.success && result.locations && result.locations.length > 0) {
            this.displayAllLocations(result.locations, lat, lng);
          } else {
            this.displayNoLocationsFound();
          }
        } catch (error) {
          console.error('Error fetching locations:', error);
          this.displayNoLocationsFound();
        } finally {
          this.hideLoadingState();
        }
      }

      displayAllLocations(locations, userLat, userLng) {
        const locationsList = this.locationResults?.querySelector('.pickup-locations-list');
        if (!locationsList) return;

        // Hide the intro and geo prompt
        const intro = this.locationResults.querySelector('.pickup-site-intro');
        const geoPrompt = this.locationResults.querySelector('.geolocation-prompt');
        if (intro) intro.style.display = 'none';
        if (geoPrompt) geoPrompt.style.display = 'none';

        // Hide zip code input
        this.hideZipCodeInput();

        // Show confirmation of search
        const confirmationHtml = `
          <div class="location-search-confirmation" style="text-align: center; margin-bottom: 1rem; padding: 0.75rem; background: var(--scheme-badges-background, #f5f5f5); border-radius: 4px;">
            <span>Showing ${locations.length} location${locations.length !== 1 ? 's' : ''} within ${this.pickupRadiusMiles} miles</span>
            <button type="button" class="change-location-search" style="margin-left: 1rem; background: none; border: none; text-decoration: underline; cursor: pointer; color: inherit;">Change</button>
          </div>
        `;

        // Build locations HTML
        let locationsHtml = '<div class="locations-grid" style="display: flex; flex-direction: column; gap: 1rem;">';

        locations.forEach((location, index) => {
          const distance = location.distance ? `${Math.round(location.distance)} miles away` : '';
          const address = location.address ?
            `${location.address.address1 || ''}, ${location.address.city || ''}, ${location.address.province || ''}` :
            '';

          locationsHtml += `
            <div class="pickup-location-card" data-location-id="${location.id}" style="
              border: 2px solid var(--scheme-borders-color, #ddd);
              border-radius: 8px;
              padding: 1rem;
              cursor: pointer;
              transition: all 0.2s ease;
            ">
              <div style="display: flex; justify-content: space-between; align-items: flex-start;">
                <div>
                  <div style="font-weight: 600; font-size: 1.1rem; margin-bottom: 0.25rem;">${location.name}</div>
                  <div style="color: #666; font-size: 0.9rem;">${address}</div>
                  ${distance ? `<div style="color: #888; font-size: 0.85rem; margin-top: 0.25rem;">${distance}</div>` : ''}
                </div>
                <div class="location-select-indicator" style="
                  width: 24px;
                  height: 24px;
                  border: 2px solid var(--scheme-borders-color, #ddd);
                  border-radius: 50%;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  flex-shrink: 0;
                  margin-left: 1rem;
                ">
                  <svg class="check-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" style="display: none;">
                    <polyline points="20 6 9 17 4 12"></polyline>
                  </svg>
                </div>
              </div>
            </div>
          `;
        });

        locationsHtml += '</div>';

        locationsList.innerHTML = confirmationHtml + locationsHtml;
        locationsList.style.display = 'block';

        // Add click handlers for location selection
        locationsList.querySelectorAll('.pickup-location-card').forEach(card => {
          card.addEventListener('click', () => this.selectPickupLocation(card, locations));
        });

        // Add change button handler
        const changeBtn = locationsList.querySelector('.change-location-search');
        if (changeBtn) {
          changeBtn.addEventListener('click', () => this.resetPickupSiteSearch());
        }
      }

      selectPickupLocation(selectedCard, locations) {
        // Remove selection from all cards
        this.locationResults.querySelectorAll('.pickup-location-card').forEach(card => {
          card.style.borderColor = 'var(--scheme-borders-color, #ddd)';
          card.style.background = 'transparent';
          card.querySelector('.check-icon').style.display = 'none';
          card.querySelector('.location-select-indicator').style.borderColor = 'var(--scheme-borders-color, #ddd)';
          card.querySelector('.location-select-indicator').style.background = 'transparent';
        });

        // Select this card
        selectedCard.style.borderColor = 'var(--scheme-text-color, #333)';
        selectedCard.style.background = 'var(--scheme-badges-background, #f5f5f5)';
        const indicator = selectedCard.querySelector('.location-select-indicator');
        indicator.style.borderColor = 'var(--scheme-text-color, #333)';
        indicator.style.background = 'var(--scheme-text-color, #333)';
        const checkIcon = selectedCard.querySelector('.check-icon');
        checkIcon.style.display = 'block';
        checkIcon.style.stroke = 'var(--scheme-background-color, #fff)';

        // Store selected location
        const locationId = selectedCard.dataset.locationId;
        const selectedLocation = locations.find(loc => loc.id == locationId);
        this.selectedPickupLocation = selectedLocation;

        // Add location as a hidden input for cart properties
        this.setPickupLocationProperty(selectedLocation);

        // Enable add to cart - need to bypass builder validation for pickup site mode
        this.enableAddToCartForPickupSite();
      }

      enableAddToCartForPickupSite() {
        const productMain = this.closest('.product-main-element') || document.querySelector('.product-main-element');
        if (!productMain) return;

        // Find and enable the add to cart button
        const addButton = productMain.querySelector('.btn.add') ||
                          productMain.querySelector('builder-buttons .btn') ||
                          productMain.querySelector('button[type="submit"]');
        if (addButton) {
          addButton.classList.remove('disabled');
          addButton.removeAttribute('disabled');
        }

        // Hide the "steps missing" feedback message
        const feedbackMsg = productMain.querySelector('.feedback-msg-sticky');
        if (feedbackMsg) {
          feedbackMsg.classList.add('hide');
        }

        // Mark all steps as not required in the builder's stepsData
        if (this.builder && this.builder.stepsData) {
          this.builder.stepsData.forEach(step => {
            step.notRequired = true;
          });
        }

        // Trigger a refresh of the builder buttons if available
        const builderButtons = productMain.querySelector('builder-buttons');
        if (builderButtons && builderButtons.refresh) {
          builderButtons.refresh();
        }
      }

      setPickupLocationProperty(location) {
        // Find the form
        const form = this.closest('form') || document.querySelector('form[action*="/cart/add"]');

        // Remove existing pickup location inputs (check both component and form)
        const existingInput = form?.querySelector('input[name*="Pickup Location"]') ||
                              this.querySelector('input[name*="Pickup Location"]');
        if (existingInput) existingInput.remove();
        const existingIdInput = form?.querySelector('input[name*="_pickup_location_id"]') ||
                                this.querySelector('input[name*="_pickup_location_id"]');
        if (existingIdInput) existingIdInput.remove();

        // Add hidden inputs with selected location name and ID
        if (form && location) {
          const hiddenInput = document.createElement('input');
          hiddenInput.type = 'hidden';
          hiddenInput.name = 'items[0][properties[Pickup Location]]';
          hiddenInput.value = location.name;
          form.appendChild(hiddenInput);

          const hiddenIdInput = document.createElement('input');
          hiddenIdInput.type = 'hidden';
          hiddenIdInput.name = 'items[0][properties[_pickup_location_id]]';
          hiddenIdInput.value = location.id;
          form.appendChild(hiddenIdInput);

          // Find the variant ID input - try multiple selectors
          // The form uses items[X][id] format for cart add
          let variantInput = form.querySelector('input.single-option-selector[data-variant-id="true"]');
          if (!variantInput) {
            // Try to find by name pattern - look for items[0][id] specifically
            variantInput = form.querySelector('input[name="items[0][id]"]');
          }
          if (!variantInput) {
            // Fallback - any input with name ending in [id]
            const allInputs = form.querySelectorAll('input[type="hidden"]');
            for (const input of allInputs) {
              if (input.name && input.name.match(/items\[\d+\]\[id\]$/)) {
                variantInput = input;
                break;
              }
            }
          }

          // Get the real variant ID (not the fake builder variant)
          let realVariantId = null;

          // Method 1: From product JSON on the page - filter out fake variants
          const productJson = document.querySelector('[data-product-json]');
          if (productJson) {
            try {
              const productData = JSON.parse(productJson.textContent);
              if (productData.variants && productData.variants.length > 0) {
                // Fake variants have IDs >= 99999999999900 (very large numbers)
                // Real Shopify variant IDs are much smaller
                const realVariants = productData.variants.filter(v => {
                  const variantId = parseInt(v.id, 10);
                  return variantId < 99999999999900;
                });
                if (realVariants.length > 0) {
                  const availableVariant = realVariants.find(v => v.available) || realVariants[0];
                  if (availableVariant) {
                    realVariantId = availableVariant.id;
                  }
                }
              }
            } catch (e) {
              console.error('Error parsing product JSON:', e);
            }
          }

          // Method 2: From builder's tmpVariants (also filter fake variants)
          if (!realVariantId && this.builder && this.builder.tmpVariants) {
            const realVariants = this.builder.tmpVariants.filter(v => {
              const variantId = parseInt(v.id, 10);
              return variantId < 99999999999900;
            });
            if (realVariants.length > 0) {
              const availableVariant = realVariants.find(v => v.available) || realVariants[0];
              if (availableVariant) {
                realVariantId = availableVariant.id;
              }
            }
          }

          // Set the variant ID on the input
          if (realVariantId) {
            if (variantInput) {
              variantInput.value = realVariantId;
              console.log('Set existing variant input to:', realVariantId);
            } else {
              // Create the variant input if it doesn't exist
              const newVariantInput = document.createElement('input');
              newVariantInput.type = 'hidden';
              newVariantInput.name = 'items[0][id]';
              newVariantInput.value = realVariantId;
              newVariantInput.className = 'single-option-selector';
              newVariantInput.setAttribute('data-variant-id', 'true');
              form.appendChild(newVariantInput);
              console.log('Created new variant input with:', realVariantId);
            }
          } else {
            console.error('Could not find real variant ID for pickup site product');
          }
        }
      }

      resetPickupSiteSearch() {
        // Reset the UI to initial state
        this.selectedPickupLocation = null;
        this.userCoordinates = null;
        this.currentZipCode = null;
        this.zipCodeEntered = false;

        // Remove pickup location property
        const existingInput = this.querySelector('input[name*="Pickup Location"]');
        if (existingInput) existingInput.remove();

        // Disable add to cart again if preventBuy is set
        if (this.addToCartButton && this.preventBuy) {
          this.addToCartButton.setAttribute('disabled', 'disabled');
        }

        // Re-show the pickup site UI
        this.showPickupSiteUI();
      }

      displayNoLocationsFound() {
        const locationsList = this.locationResults?.querySelector('.pickup-locations-list');
        if (!locationsList) return;

        locationsList.innerHTML = `
          <div style="text-align: center; padding: 2rem; color: #666;">
            <div style="font-size: 1.1rem; margin-bottom: 0.5rem;">No pickup locations found nearby</div>
            <div style="font-size: 0.9rem;">Try a different zip code or contact us for assistance.</div>
            <button type="button" class="change-location-search" style="margin-top: 1rem; background: none; border: 1px solid; padding: 0.5rem 1rem; cursor: pointer; border-radius: 4px;">Try Again</button>
          </div>
        `;
        locationsList.style.display = 'block';

        const changeBtn = locationsList.querySelector('.change-location-search');
        if (changeBtn) {
          changeBtn.addEventListener('click', () => this.resetPickupSiteSearch());
        }
      }
  
      onEventTypeChange() {
        if(this.eventTypeSelector.value == '') {
          this.eventTypeSelector.removeAttribute('name');
          return;
        }
        this.eventTypeSelector.setAttribute('name', this.eventTypeSelector.dataset.name);

        if(!this.builder) return;
        this.builder.dispatchEvent(new CustomEvent('stepChange', {detail: {eventType: this.eventTypeSelector.value}}));
      }
      onDateChange() {
        const currentHour = new Date().getHours();
        const date = new Date(this.datePicker.value + 'T' + (currentHour < 12 ? '12:00:00' : '23:59:59'));
        const productBloomBoxCheckbox = this.querySelector('[name="bloom_box"][data-product="true"]') || document.querySelector('.custom-card-event[name="bloom_box"][data-product="true"]');
  
        if (this.datePicker.value && this.datePicker.value !== '') {
          const diffDays = this.daysUntil(date);
          
          // Store existing zip code state before making changes
          const hadZipCode = this.zipCodeEntered;
          const existingZipCode = this.currentZipCode;
          
          // Reset zip code input field but preserve state for restoration
          if (this.zipCodeInput) {
            this.zipCodeInput.value = '';
          }
    
          if (diffDays < -4) {
            // Old events: Reset state and show recreation options
            this.zipCodeEntered = false;
            this.currentZipCode = null;
            this.hideZipCodeInput();
            this.hideZipCodeConfirmation();
            this.hideShippingOptions();
            this.showRecreationOptions();
            return;
          } else if (diffDays >= -4 && diffDays <= 2) {
            // Near-term events: Show zip code input for pickup/shipping label options
            this.showZipCodeInput();
            this.enableZipCodeInput();
            this.hideShippingOptions();
            
            // Restore zip code state if we had one
            if (hadZipCode && existingZipCode) {
              this.zipCodeEntered = true;
              this.currentZipCode = existingZipCode;
              this.showZipCodeConfirmation(existingZipCode);
              // Re-check availability with existing zip
              this.checkPickupAvailability(existingZipCode);
            } else {
              this.hideZipCodeConfirmation();
            }
          } else if (diffDays >= 3) {
            // Future events: Reset state and show regular bloom box directly
            this.zipCodeEntered = false;
            this.currentZipCode = null;
            this.hideZipCodeInput();
            this.hideZipCodeConfirmation();
            this.showRegularBloomBox();
          }
        } else {
          this.hideZipCodeInput();
          this.hideZipCodeConfirmation();
        }

        // Only process bloom box logic if we have a valid date
        if (this.datePicker.value && this.datePicker.value !== '') {
          const eventDate = new Date(this.datePicker.value + 'T12:00:00');
          const diffDays = this.daysUntil(eventDate);
          
          if (diffDays >= -4) {
            // Only handle bloom box messages for events that aren't too old
            if(this.bloomsSelector) {
          this.bloomsSelector.forEach((selector)=>{
            selector.checked = false;
          });
        }

        if(this.bloomProductInputs) {
          this.bloomProductInputs.forEach((input)=>{
            input.removeAttribute('name');
          });
        }

        if(this.shippingLabelSelector) {
          this.shippingLabelSelector.forEach((selector)=>{
            selector.checked = false;
          });
        }

        if(this.shippingLabelProductInputs) {
          this.shippingLabelProductInputs.forEach((input)=>{
            input.removeAttribute('name');
          });
        }

        if(this.messageTurnaround) this.handleTournAroundMessage(date);
       
        if(this.bloomsBoxAvailabilityDays && this.daysUntil(date) >= this.bloomsBoxAvailabilityDays) {
          if (productBloomBoxCheckbox) {
            productBloomBoxCheckbox.removeAttribute('disabled');
            productBloomBoxCheckbox.closest('.swatch-group').classList.remove('hide');
          }
          this.bloomsBoxAvailable = true;
        } else {
          if (productBloomBoxCheckbox) {
            productBloomBoxCheckbox.setAttribute('disabled', 'disabled');
            productBloomBoxCheckbox.closest('.swatch-group').classList.add('hide');
          }
          this.bloomsBoxAvailable = false;
        }

            // Only show bloom box messages for events that aren't too old
            if(this.messageBlooms && diffDays >= -4) {
              this.handleBloomsBoxMessage(date);
            } else if (this.messageBlooms && diffDays < -4) {
              // Hide message for old events
              this.messageBlooms.style.display = 'none';
            }
          }
        } else {
          // No date selected - hide all bloom box UI
          if (this.messageBlooms) {
            this.messageBlooms.style.display = 'none';
          }
        }

        if(this.preventBuy){
          if(this.bloomsBoxAvailable){
            this.addToCartButton.removeAttribute('disabled');
          } else {
            this.addToCartButton.setAttribute('disabled', 'disabled');
          }
        }

        // Test formatting: the shipping card's footnote names the chosen event
        // date (the element only renders when the section's test formatting is on)
        const kitFootnote = this.querySelector('.shipping-kit-footnote');
        if (kitFootnote) {
          if (this.bloomsBoxAvailable && this.datePicker.value && !isNaN(date.getTime())) {
            kitFootnote.querySelector('.shipping-kit-footnote-date').textContent =
              ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
            kitFootnote.hidden = false;
          } else {
            kitFootnote.hidden = true;
          }
        }

        if(!this.builder) return;
        this.builder.dispatchEvent(new CustomEvent('stepChange', {detail: {}}));
      }

      onEventDateChange() {
        const currentHour = new Date().getHours();
        const date = new Date(this.eventDatePicker.value + 'T' + (currentHour < 12 ? '12:00:00' : '23:59:59'));
        const diffDays = this.daysUntil(date);
        // Apply the same zip code logic as onDateChange
        if (diffDays < -4) {
          this.hideZipCodeInput();
          this.hideZipCodeConfirmation();
          this.showRecreationOptions();
        } else if (diffDays >= -4 && diffDays <= 2) {
          this.showZipCodeInput();
          this.enableZipCodeInput();
          // Restore zip confirmation if we had a zip code entered
          if (this.zipCodeEntered && this.currentZipCode) {
            this.showZipCodeConfirmation(this.currentZipCode);
          }
        } else if (diffDays >= 3) {
          this.hideZipCodeInput();
          this.hideZipCodeConfirmation();
          this.showRegularBloomBox();
        }
        
        const eventMessageElement = document.querySelector(".custom-card-event .event-message");

        if(eventMessageElement) {
          this.handleEventBloomsBoxMessage(date);
        }
      }
  
      onBloomsSelectorChange(e) {
        this.handleProductInputs(e.target);
        if(!this.builder) return;
        this.builder.dispatchEvent(new CustomEvent('bundleChange', {detail: {}}));
      }

      onShippingLabelSelectorChange(e) {
        this.handleShippingLabelProductInputs(e.target);
        if(!this.builder) return;
        this.builder.dispatchEvent(new CustomEvent('bundleChange', {detail: {}}));
      }

      handleProductInputs(input){
        if(input.checked) {
          this.bloomProductInputs.forEach((input)=>{
            input.setAttribute('name', input.dataset.name);
          });
          return;
        }
        
        this.bloomProductInputs.forEach((input)=>{
          input.removeAttribute('name');
        });
      }

      handleShippingLabelProductInputs(input){
        if(input.checked) {
          this.shippingLabelProductInputs.forEach((input)=>{
            input.setAttribute('name', input.dataset.name);
          });
          return;
        }
        
        this.shippingLabelProductInputs.forEach((input)=>{
          input.removeAttribute('name');
        });
      }

      // New zip code handling methods
      onZipCodeInput(e) {
        const zipCode = e.target.value.trim();
        // Prevent multiple calls for the same zip code
        if (this.currentZipCode === zipCode) {
          return;
        }
        
        // Basic validation - trigger lookup when we have 5 digits
        if (zipCode.length === 5 && /^\d{5}$/.test(zipCode)) {
          this.currentZipCode = zipCode;
          this.zipCodeEntered = true;
          // Hide the "Please enter zip code" message immediately
          if (this.messageBlooms) {
            this.messageBlooms.style.display = 'none';
          }
          this.checkPickupAvailability(zipCode);
        } else {
          this.zipCodeEntered = false;
          this.hideShippingOptions();
        }
      }

      onZipCodeBlur(e) {
        // Trigger search when user leaves the zip code input field
        this.onZipCodeSearch(e);
      }

      onZipCodeSearch(e) {
        const zipCode = this.zipCodeInput.value.trim();

        // Prevent multiple calls for the same zip code
        if (this.currentZipCode === zipCode) {
          return;
        }

        // Basic validation - trigger lookup when we have 5 digits
        if (zipCode.length === 5 && /^\d{5}$/.test(zipCode)) {
          this.currentZipCode = zipCode;
          this.zipCodeEntered = true;

          // Show loading state
          this.showLoadingState();

          // Hide the "Please enter zip code" message immediately
          if (this.messageBlooms) {
            this.messageBlooms.style.display = 'none';
          }

          // In pickup site mode, geocode the zip and find all locations
          if (this.pickupSiteMode) {
            this.geocodeZipAndFindLocations(zipCode);
          } else {
            this.checkPickupAvailability(zipCode);
            this.showZipCodeConfirmation(zipCode);
          }
        }
      }

      async geocodeZipAndFindLocations(zipCode) {
        try {
          // Use zippopotam.us to convert zip code to coordinates (same as existing theme)
          const response = await fetch(`https://api.zippopotam.us/us/${zipCode}`);

          if (response.ok) {
            const zipData = await response.json();
            const lat = parseFloat(zipData.places[0].latitude);
            const lng = parseFloat(zipData.places[0].longitude);
            this.userCoordinates = { lat, lng };
            this.findAllNearbyLocations(lat, lng);
          } else {
            console.error('Geocoding failed for zip:', zipCode);
            this.displayNoLocationsFound();
            this.hideLoadingState();
          }
        } catch (error) {
          console.error('Error geocoding zip code:', error);
          this.displayNoLocationsFound();
          this.hideLoadingState();
        }
      }

      showLoadingState() {
        const searchBtn = this.querySelector('.zip-search-btn');
        if (searchBtn) {
          searchBtn.classList.add('loading');
        }
      }

      hideLoadingState() {
        const searchBtn = this.querySelector('.zip-search-btn');
        if (searchBtn) {
          searchBtn.classList.remove('loading');
        }
      }

      getFromCache(key) {
        try {
          const cacheData = localStorage.getItem(`pf_cache_${key}`);
          if (!cacheData) return null;
          
          const parsed = JSON.parse(cacheData);
          if (Date.now() > parsed.expiry) {
            localStorage.removeItem(`pf_cache_${key}`);
            return null;
          }
          
          return parsed.data;
        } catch (error) {
          return null;
        }
      }

      saveToCache(key, data, ttlMs) {
        try {
          const cacheData = {
            data: data,
            expiry: Date.now() + ttlMs
          };
          localStorage.setItem(`pf_cache_${key}`, JSON.stringify(cacheData));
        } catch (error) {
          // Silently fail if localStorage is not available or full
        }
      }

      showRecommendationsLoading() {
        this.locationResults.classList.add('loading');
        this.locationResults.innerHTML = `
          <div class="recommendations-loading-spinner"></div>
          <div class="loading-text">Finding shipping recommendations...</div>
        `;
        this.locationResults.style.display = 'flex';
        this.locationResultsTitle.style.display = 'flex';
      }

      hideRecommendationsLoading() {
        this.locationResults.classList.remove('loading');
      }

      showZipCodeConfirmation(zipCode) {
        const confirmation = document.querySelector('.zip-code-confirmation');
        const confirmedZip = document.querySelector('.confirmed-zip');
        const changeBtn = document.querySelector('.zip-change-btn');
        
        if (confirmation && confirmedZip) {
          confirmedZip.textContent = zipCode;
          confirmation.style.display = 'block';
          
          // Hide the zip code input section
          this.hideZipCodeInput();
          
          // Add event listener to change button
          if (changeBtn) {
            changeBtn.addEventListener('click', () => {
              this.resetZipCodeInput();
            });
          }
        }
      }

      resetZipCodeInput() {
        // Hide confirmation
        this.hideZipCodeConfirmation();
        
        // Show and reset zip code input
        this.showZipCodeInput();
        this.zipCodeInput.value = '';
        this.zipCodeEntered = false;
        this.currentZipCode = null;
        
        // Hide shipping options
        this.hideShippingOptions();
        
        // Show the "Please enter zip code" message
        if (this.messageBlooms) {
          this.messageBlooms.style.display = 'block';
        }
      }

      hideZipCodeConfirmation() {
        const confirmation = document.querySelector('.zip-code-confirmation');
        if (confirmation) {
          confirmation.style.display = 'none';
        }
      }

      async checkPickupAvailability(zipCode) {
        // Prevent overlapping async calls
        if (this.isProcessingZipCode) {
          return;
        }
        
        this.isProcessingZipCode = true;
        
        // Show loading state in recommendations container
        this.showRecommendationsLoading();
        
        try {
          // Check cache first for better performance
          const cacheKey = `zip_${zipCode}`;
          const cachedData = this.getFromCache(cacheKey);
          
          let combinedData;
          if (cachedData) {
            combinedData = cachedData;
          } else {
            // Get both inventory-based locations and all locations for drop-off checking
            const [inventoryLocations, allLocations] = await Promise.all([
              this.getLocationData(zipCode, true),  // With inventory requirement
              this.getLocationData(zipCode, false)  // All locations for drop-off
            ]);
            
            // Combine the data for decision making
            combinedData = {
              success: inventoryLocations.success || allLocations.success,
              inventoryLocations: inventoryLocations.locations || [],
              allLocations: allLocations.locations || []
            };
            
            // Cache the result for 5 minutes to improve performance
            this.saveToCache(cacheKey, combinedData, 5 * 60 * 1000);
          }
          
          if (combinedData.success && (combinedData.inventoryLocations.length > 0 || combinedData.allLocations.length > 0)) {
            // Found nearby locations
            this.nearPickupLocation = combinedData.inventoryLocations.length > 0;
            this.showShippingOptions(zipCode, combinedData);
          } else {
            // No nearby locations found
            this.nearPickupLocation = false;
            this.showShippingOptions(zipCode, null);
          }
        } catch (error) {
          this.nearPickupLocation = false;
          this.showShippingOptions(zipCode, null);
        } finally {
          this.isProcessingZipCode = false;
          this.hideLoadingState();
        }
      }

      async getLocationData(zipCode, requireInventory = true) {
        try {
          // Step 1: Convert zip code to coordinates using geocoding
          const coordinates = await this.geocodeZipCode(zipCode);
          if (!coordinates) {
            return { success: false, zip_code: zipCode, locations: [] };
          }

          // Step 2: Query Shopify locations near these coordinates
          const shopifyLocations = await this.queryShopifyLocations(coordinates.lat, coordinates.lng, requireInventory);
          if (!shopifyLocations || shopifyLocations.length === 0) {
            return { success: false, zip_code: zipCode, locations: [] };
          }

          // Step 3: Format locations for display (filtering already done by Netlify function)
          const availableLocations = shopifyLocations.map(location => ({
            id: location.id,
            name: location.name,
            city: location.address.city,
            state: location.address.province,
            distance: `${Math.round(location.distance)} miles`,
            address: `${location.address.address1}, ${location.address.city}, ${location.address.province}`,
            hasInventory: location.hasInventory,
            inventoryQuantity: location.inventoryQuantity
          }));
          
          return {
            success: availableLocations.length > 0,
            zip_code: zipCode,
            locations: availableLocations
          };
        } catch (error) {
          return { success: false, zip_code: zipCode, locations: [] };
        }
      }

      async geocodeZipCode(zipCode) {
        try {
          // Use a free geocoding service to convert zip code to coordinates
          const response = await fetch(`https://api.zippopotam.us/us/${zipCode}`);
          
          if (!response.ok) {
            throw new Error(`Geocoding failed: ${response.status}`);
          }

          const data = await response.json();
          
          if (data.places && data.places.length > 0) {
            const place = data.places[0];
            return {
              lat: parseFloat(place.latitude),
              lng: parseFloat(place.longitude),
              city: place['place name'],
              state: place['state abbreviation']
            };
          }
          
          return null;
        } catch (error) {
          return null;
        }
      }

      async queryShopifyLocations(lat, lng, requireInventory = true) {
        try {
          // Add parameter to control inventory requirement
          const inventoryParam = requireInventory ? '&inventory=true' : '&inventory=false';
          const response = await fetch(`https://pf-shopify-locations-api.netlify.app/.netlify/functions/locations?lat=${lat}&lng=${lng}${inventoryParam}`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json'
            }
          });

          if (!response.ok) {
            console.warn('Server locations endpoint failed, using fallback');
          }

          const result = await response.json();
          
          if (result.success && result.locations && result.locations.length > 0) {
            return result.locations.map(location => ({
              id: location.id,
              name: location.name,
              address: location.address,
              distance: location.distance, // Server should calculate this
              hasInventory: location.hasInventory,
              inventoryQuantity: location.inventoryQuantity,
            }));
          }
        } catch (error) {
          console.error('Server locations query error:', error);
        }
      }

      async filterLocationsWithInventory(locations) {
        // Filter to only show locations within 30 miles that have inventory
        const maxDistanceMiles = 30;
        
        return locations
          .filter(location => location.distance <= maxDistanceMiles)
          .map(location => ({
            id: location.id,
            name: location.name,
            address: location.address,          // Keep original address object
            coordinates: location.coordinates,   // Keep coordinates for map
            city: location.address.city,
            state: location.address.province,
            distance: `${Math.round(location.distance)} miles`,
            addressString: `${location.address.address1}, ${location.address.city}, ${location.address.province}`,
            hasInventory: location.hasInventory
          }))
          .filter(location => location.hasInventory); // Only show locations with inventory
      }

      calculateDistance(lat1, lon1, lat2, lon2) {
        // Haversine formula to calculate distance in miles
        const R = 3959; // Earth's radius in miles
        const dLat = (lat2 - lat1) * Math.PI / 180;
        const dLon = (lon2 - lon1) * Math.PI / 180;
        const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                  Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
                  Math.sin(dLon / 2) * Math.sin(dLon / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        return R * c;
      }

      showShippingOptions(zipCode, locationData) {
        if (!this.locationResults) return;
        
        // Remove loading state when showing results
        this.hideRecommendationsLoading();
        
        const eventDate = new Date(this.datePicker.value + 'T12:00:00');
        const diffDays = this.daysUntil(eventDate);
        
        // Corrected logic based on business requirements:
        if (diffDays < -4) {
          // More than 4 days in the past: Show recreation options
          this.showRecreationOptions();
        } else if (diffDays >= -4 && diffDays <= 2) {
          // Between 4 days past and 2 days future: Near-term event logic
          
          // Check for drop-off availability first (highest priority)
          const dropOffLocation = this.checkDropOffAvailability(locationData);
          
          if (dropOffLocation) {
            this.showDropOffOption(zipCode, dropOffLocation);
          } else if (this.nearPickupLocation && locationData && locationData.inventoryLocations && locationData.inventoryLocations.length > 0) {
            this.showPickupLocation(zipCode, locationData.inventoryLocations[0]);
          } else {
            this.showShippingLabel(zipCode);
          }
        } else if (diffDays >= 3) {
          // 3+ days in the future: Always show regular shipped bloom box
          this.showRegularBloomBox(zipCode);
        }
        
        this.locationResults.style.display = 'block';
        this.locationResultsTitle.style.display = 'block';
      }

      showRegularBloomBox(zipCode = null) {
        // Show recommendation text in location results
        const basedOnText = this.zipCodeEntered ? 
          this.eventData.based_on_text.replace('event date', 'event date and zip code') : 
          this.eventData.based_on_text;
        this.locationResults.innerHTML = `
          <div style="text-align: center; font-style: italic; margin-bottom: 1rem;">
            <div style="font-size: 16px !important; margin-bottom: 8px;">${basedOnText}</div>
            <div style="font-size: 16px !important;">${this.eventData.blooms_box_shipped_message}</div>
          </div>
        `;
        this.locationResults.style.display = 'block';
        this.locationResultsTitle.style.display = 'block';
        // Show the swatch-group container
        const swatchGroup = this.querySelector('.swatch-group');
        if (swatchGroup) {
          swatchGroup.style.display = 'flex';
        }
        
        // Show the bloom box swatch specifically
        const bloomBoxSwatch = this.querySelector('.swatch:not(.shipping-label-swatch)');
        if (bloomBoxSwatch) {
          bloomBoxSwatch.style.display = 'block';
        }
        
        // Hide shipping label swatch 
        const shippingLabelSwatch = this.querySelector('.shipping-label-swatch');
        if (shippingLabelSwatch) {
          shippingLabelSwatch.style.display = 'none';
        }
      }

      showPickupLocation(zipCode, location) {
        const pickupProduct = this.eventData.pickup_bloom_product;
        const shippingLabelProduct = this.eventData.bloom_shipping_label_product;
        const bundlePrice = pickupProduct.price + (shippingLabelProduct ? shippingLabelProduct.price : 0);
        const shippingLabelMessage = this.eventData.bloom_shipping_label_text || `Using our Shipping Label to get our discounted rates and package on your own.<br>Instructions can be found <a href="#open-info-modal" style="z-index: 1;">here</a> and will be sent to you after checkout.`;
        const shippingLabelOptionHTML = shippingLabelProduct && shippingLabelProduct.variant_id ? `
          <div class="pickup-shipping-choice-divider" aria-hidden="true">
            <span>or</span>
          </div>

          <div class="swatch shipping-kit-swatch pickup-shipping-label-swatch">
            <input
              type="checkbox"
              name="shipping_label"
              id="dynamic-pickup-shipping-label"
              value="shipping_label_product"
              data-label="Shipping Label"
              aria-label="Shipping Label"
            >
            <label for="dynamic-pickup-shipping-label" class="scheme-border-box animation shipping-kit-label">
              <img
                src="${shippingLabelProduct.image_url || 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZyI+PHBhdGggZD0iTTMwIDUwYzExLjA0NiAwIDIwLTguOTU0IDIwLTIwcy04Ljk1NC0yMC0yMC0yMFMxMCAxOC45NTQgMTAgMzBzOC45NTQgMjAgMjAgMjAiIHN0cm9rZT0iIzMzMyIgc3Ryb2tlLXdpZHRoPSIyIi8+PC9zdmc+'}"
                class="shipping-kit-image"
                alt="Shipping Label"
                width="83"
                height="80"
              >
              <div class="shipping-kit-details">
                <div class="shipping-kit-title">${this.eventData.bloom_shipping_label_title || 'Pre-paid Overnight Shipping Label'}</div>
                <div class="shipping-kit-description">${shippingLabelMessage}</div>
                <a href="#shipping-label-info-modal" class="link learn-more open-shipping-label-info">Learn More</a>
              </div>
              <div class="shipping-kit-actions">
                <div class="btn add">
                  ADD | $${(shippingLabelProduct.price / 100).toFixed(0)}
                </div>
                <div class="link remove">Remove</div>
              </div>
            </label>

            <div class="shipping-label-product pickup-shipping-label-product" data-price="${shippingLabelProduct.price}" data-bf-eligible="${shippingLabelProduct.bf_eligible === true}" data-bf-product-id="${shippingLabelProduct.id}" data-bf-blocked="${shippingLabelProduct.bf_blocked !== false}">
              <input
                class="single-option-selector"
                type="hidden"
                data-name="items[4][id]"
                value="${shippingLabelProduct.variant_id}"
              >
              <input
                type="hidden"
                data-name="items[4][properties[_bundle_item]]"
                value="related_multiple"
              >
              <input
                type="hidden"
                data-name="items[4][properties[_bundle_id]]"
              >
              <input
                type="hidden"
                data-name="items[4][quantity]"
                value="1"
              >
            </div>
          </div>
        ` : '';

        // Hide existing swatches
        const swatchGroup = this.querySelector('.swatch-group');
        if (swatchGroup) {
          swatchGroup.style.display = 'none';
        }

        // Clear any existing bloom product selections to prevent conflicts
        if (this.bloomsSelector) {
          this.bloomsSelector.forEach((selector) => {
            selector.checked = false;
          });
        }
        if (this.bloomProductInputs) {
          this.bloomProductInputs.forEach((input) => {
            input.removeAttribute('name');
          });
        }
        // Also clear shipping label inputs
        if (this.shippingLabelProductInputs) {
          this.shippingLabelProductInputs.forEach((input) => {
            input.removeAttribute('name');
          });
        }

        // Create dynamic pickup swatch HTML
        const basedOnText = this.zipCodeEntered ?
          this.eventData.based_on_text.replace('event date', 'event date and zip code') :
          this.eventData.based_on_text;
        this.locationResults.innerHTML = `
          <div style="text-align: center; font-style: italic; margin-bottom: 1rem;">
            <div style="font-size: 16px !important; margin-bottom: 8px;">${basedOnText}</div>
            <div style="font-size: 16px !important;">${this.eventData.blooms_box_pickup_message}</div>
          </div>

          <div class="swatch-group flex pickup-shipping-choice-group">
            <div class="swatch shipping-kit-swatch pickup-bloom-swatch">
            <input
              type="checkbox"
              name="bloom_box"
              id="dynamic-pickup-bloom-box"
              value="pickup_bloom_box_product"
              data-label="Bloom Shipping Box + Overnight Label"
              aria-label="Bloom Shipping Box + Overnight Label"
            >
            <label for="dynamic-pickup-bloom-box" class="scheme-border-box animation shipping-kit-label">
              <img
                src="${pickupProduct.image_url || 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTMwIDUwYzExLjA0NiAwIDIwLTguOTU0IDIwLTIwcy04Ljk1NC0yMC0yMC0yMFMxMCAxOC45NTQgMTAgMzBzOC45NTQgMjAgMjAgMjAiIHN0cm9rZT0iIzMzMyIgc3Ryb2tlLXdpZHRoPSIyIi8+PC9zdmc+'}"
                class="shipping-kit-image"
                alt="Bloom Shipping Box + Overnight Label"
                width="83"
                height="80"
              >
              <div class="shipping-kit-details">
                <div class="shipping-kit-title">Bloom Shipping Box +<span class="mobile-break"></span> Overnight Label</div>
                <a href="#carousel-info-popup" class="link learn-more open-bloom-box-popup">Learn More</a>
              </div>
              <div class="shipping-kit-actions">
                <div class="btn add">
                  ADD | $${(bundlePrice / 100).toFixed(0)}
                </div>
                <div class="link remove">Remove</div>
              </div>
            </label>

            <div class="bloom-product pickup-bloom-product shipping-kit-bundle" data-price="${bundlePrice}" data-bf-eligible="${pickupProduct.bf_eligible === true}" data-bf-product-id="${pickupProduct.id}" data-bf-blocked="${pickupProduct.bf_blocked !== false}" data-bf-extra-product-id="${shippingLabelProduct?.id || ''}" data-bf-extra-blocked="${shippingLabelProduct?.bf_blocked !== false}" data-bf-extra="${shippingLabelProduct?.price || 0}" data-bf-extra-eligible="${shippingLabelProduct?.bf_eligible === true}">
              <input
                class="single-option-selector"
                type="hidden"
                data-name="items[4][id]"
                value="${pickupProduct.variant_id}"
              >
              <input
                type="hidden"
                data-name="items[4][properties[Pickup Location]]"
                value="${location.name}"
              >
              <input
                type="hidden"
                data-name="items[4][quantity]"
                value="1"
              >
              ${shippingLabelProduct ? `
              <input
                type="hidden"
                data-name="items[5][id]"
                value="${shippingLabelProduct.variant_id}"
              >
              <input
                type="hidden"
                data-name="items[5][quantity]"
                value="1"
              >
              ` : ''}
            </div>
          </div>

          <div class="pickup-location-info pickup-location-info--choice" style="text-align: center; margin: 0; font-style: italic;">
            Pick up at <a href="#" onclick="openPickupLocationModal(event, '${location.id || location.locationId || 'unknown'}')" style="text-decoration: underline;">${location.name}</a><br>
            <span style="color: #6c757d; font-size: 0.9rem;">${location.distance} away</span>
          </div>

          ${shippingLabelOptionHTML}
          </div>
        `;
        
        // Add event listener to the dynamic pickup checkbox
        const pickupCheckbox = this.locationResults.querySelector('#dynamic-pickup-bloom-box');
        const pickupInputs = this.locationResults.querySelectorAll('.pickup-bloom-product input[type="hidden"]');
        const shippingCheckbox = this.locationResults.querySelector('#dynamic-pickup-shipping-label');
        const shippingInputs = this.locationResults.querySelectorAll('.pickup-shipping-label-product input[type="hidden"]');
        const pickupSwatch = this.locationResults.querySelector('.pickup-bloom-swatch');
        const shippingSwatch = this.locationResults.querySelector('.pickup-shipping-label-swatch');
        const pickupLearnMore = this.locationResults.querySelector('.open-bloom-box-popup');
        const shippingLearnMore = this.locationResults.querySelector('.open-shipping-label-info');
        const instructionsLink = this.locationResults.querySelector('a[href="#open-info-modal"]');
        const activateInputs = (inputs) => {
          inputs.forEach((input) => {
            if (input.dataset.name) {
              input.setAttribute('name', input.dataset.name);
            }
          });
        };
        const deactivateInputs = (inputs) => {
          inputs.forEach((input) => {
            input.removeAttribute('name');
          });
        };
        const dispatchBundleChange = () => {
          if (this.builder) {
            this.builder.dispatchEvent(new CustomEvent('bundleChange', { detail: {} }));
          }
        };
        const bindChoiceClick = (swatch, checkbox) => {
          if (!swatch || !checkbox) return;
          swatch.addEventListener('click', (event) => {
            if (event.target.closest('a')) return;
            if (event.target === checkbox) return;
            event.preventDefault();
            checkbox.checked = !checkbox.checked;
            checkbox.dispatchEvent(new Event('change', { bubbles: true }));
          });
        };
        
        if (pickupCheckbox) {
          pickupCheckbox.addEventListener('change', (e) => {
            if (e.target.checked) {
              if (shippingCheckbox) shippingCheckbox.checked = false;
              deactivateInputs(shippingInputs);
              activateInputs(pickupInputs);
            } else {
              deactivateInputs(pickupInputs);
            }
            dispatchBundleChange();
          });
        }

        if (shippingCheckbox) {
          shippingCheckbox.addEventListener('change', (e) => {
            if (e.target.checked) {
              if (pickupCheckbox) pickupCheckbox.checked = false;
              deactivateInputs(pickupInputs);
              activateInputs(shippingInputs);
            } else {
              deactivateInputs(shippingInputs);
            }
            dispatchBundleChange();
          });
        }

        bindChoiceClick(pickupSwatch, pickupCheckbox);
        bindChoiceClick(shippingSwatch, shippingCheckbox);
        
        // Add event listener for the Learn more link
        if (pickupLearnMore) {
          pickupLearnMore.addEventListener('click', (e) => {
            const href = new URL(e.target.href);
            if (href.hash) {
              e.preventDefault();
              const popup = document.querySelector(href.hash);
              
              if (popup) {
                let popupSectionClone = popup.closest('.shopify-section').cloneNode(true);
                popupSectionClone.insertAdjacentHTML('beforeend', popup.innerHTML);
                $s.openModal(popupSectionClone, 'product-quick-view');
                $s.globalEval(popupSectionClone);
              }
            }
          });
        }

        if (shippingLearnMore) {
          shippingLearnMore.addEventListener('click', (e) => {
            e.preventDefault();
            const modalHTML = `
              <div style="padding: 4rem 2rem; max-width: 500px; background-color: white;">
                <h2 style="margin: 0 0 1rem; font-size: 24px; text-align: center;">Overnight prepaid shipping label</h2>
                <p style="font-size: 16px; line-height: 1.6; margin: 1rem 0;">
                  Our overnight shipping label provides discounted rates for you to package and ship your flowers on your own.
                </p>
                <p style="font-size: 16px; line-height: 1.6; margin: 1rem 0;">
                  You will receive the label via email within 24 hours of purchase.
                </p>
                <p style="font-size: 16px; line-height: 1.6; margin: 1rem 0;">
                  The email will have the subject line <span><strong>"Your Return Shipping Label."</strong></span> A link to detailed shipping instructions will be included in that email.
                </p>
              </div>
            `;
            $s.openModal(modalHTML, 'shipping-label-info');
          });
        }

        if (instructionsLink) {
          instructionsLink.addEventListener('click', (e) => {
            e.preventDefault();
            this.handleLinkClick(e);
          });
        }
        
        // Create pickup-specific bloom box popup template if it doesn't exist
        if (!document.querySelector('#pickup-bloom-box-popup')) {
          const pickupPopupSection = document.createElement('div');
          pickupPopupSection.className = 'shopify-section type_Carousel_Info_Popup';
          
          const pickupPopupTemplate = document.createElement('template');
          pickupPopupTemplate.id = 'pickup-bloom-box-popup';
          pickupPopupTemplate.innerHTML = `
            <div style="padding: 2rem; max-width: 500px; background-color: white;">
              <h2 style="margin: 0 0 1rem; font-size: 24px; text-align: center;">Our Bloom Shipping Box</h2>
              <ul style="font-size: 16px; line-height: 1.6; margin: 1rem 0; padding-left: 1.5rem;">
                <li>Created to be the cheapest option to transport your blooms to us after your event.</li>
                <li>Comes with a prepaid overnight shipping label, printed out and ready to stick on the box.</li>
                <li>Includes all the materials needed for your blooms to have a safe trip to us.</li>
                <li>Pick up your box at a convenient location near you.</li>
              </ul>
            </div>
          `;
          
          pickupPopupSection.appendChild(pickupPopupTemplate);
          document.body.appendChild(pickupPopupSection);
        }
        
        this.locationResults.style.display = 'block';
        this.locationResultsTitle.style.display = 'block';
      }

      checkDropOffAvailability(locationData) {
        if (!locationData || !locationData.allLocations || locationData.allLocations.length === 0) {
          return null;
        }
        
        // Check for specific drop-off locations within 50 miles
        const dropOffLocationNames = [
          'Pressed Floral Georgia',
          'Pressed Floral shop'
        ];
        
        for (const location of locationData.allLocations) {
          const distanceMatch = location.distance.match(/(\d+)/);
          const distanceMiles = distanceMatch ? parseInt(distanceMatch[1]) : 999;
          
          if (distanceMiles <= 50 && dropOffLocationNames.includes(location.name)) {
            return location;
          }
        }
        
        return null;
      }

      showDropOffOption(zipCode, location) {
        // Hide existing swatches
        const swatchGroup = this.querySelector('.swatch-group');
        if (swatchGroup) {
          swatchGroup.style.display = 'none';
        }
        
        const basedOnText = this.zipCodeEntered ? 
          this.eventData.based_on_text.replace('event date', 'event date and zip code') : 
          this.eventData.based_on_text;
        
        // Determine the shop type and address based on location name
        const shopInfo = location.name === 'Pressed Floral Georgia' 
          ? { type: 'Georgia', address: '1425 Ellsworth Industrial Blvd NW, Suite 31, Atlanta, GA' }
          : { type: 'Utah', address: '1799 N State Street, Orem, UT 84057' };
        
        this.locationResults.innerHTML = `
          <div style="text-align: center; font-style: italic; margin-bottom: 1rem;">
            <div style="font-size: 16px !important; margin-bottom: 8px;">${basedOnText}</div>
            <div style="font-size: 16px !important;">Dropping off your flowers in person at our ${shopInfo.type} shop — no need to ship your bouquet!</div>
          </div>
          
          <div style="text-align: center; margin-top: 1.5rem;">
            <div style="font-style: italic; margin-bottom: 0.5rem;">Visit us at:</div>
            <div style="font-weight: 500; margin-bottom: 0.5rem;">${shopInfo.address}</div>
            <div style="font-style: italic; color: #666;">Monday – Friday, 10am – 5pm</div>
          </div>
        `;
        
        this.locationResults.style.display = 'block';
        this.locationResultsTitle.style.display = 'block';
      }

      showShippingLabel(zipCode) {
        const product = this.eventData.bloom_shipping_label_product;
        const message = this.eventData.bloom_shipping_label_text || `Using our Shipping Label to get our discounted rates and package on your own.<br>Instructions can be found <a href="#open-info-modal" style="z-index: 1;">here</a> and will be sent to you after checkout.`;

        const basedOnText = this.zipCodeEntered ? 
          this.eventData.based_on_text.replace('event date', 'event date and zip code') : 
          this.eventData.based_on_text;
        this.locationResults.innerHTML = `
          <div style="text-align: center; font-style: italic; margin-bottom: 1rem;">
            <div style="font-size: 16px !important;">${basedOnText}</div>
          </div>
          <div class="swatch shipping-kit-swatch shipping-label-swatch" style="display: block; position: relative; z-index: 1;">
            <input
              type="checkbox"
              name="shipping_label"
              id="dynamic-shipping-label"
              value="shipping_label_product"
              data-label="Shipping Label"
              aria-label="Shipping Label"
              style="z-index: 1;"
            >
            <label for="dynamic-shipping-label" class="scheme-border-box animation shipping-kit-label">
              <img
                src="${product.image_url || 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTMwIDUwYzExLjA0NiAwIDIwLTguOTU0IDIwLTIwcy04Ljk1NC0yMC0yMC0yMFMxMCAxOC45NTQgMTAgMzBzOC45NTQgMjAgMjAgMjAiIHN0cm9rZT0iIzMzMyIgc3Ryb2tlLXdpZHRoPSIyIi8+PC9zdmc+'}"
                class="shipping-kit-image"
                alt="Shipping Label"
                width="83"
                height="80"
              >
              <div class="shipping-kit-details">
                <div class="shipping-kit-title">${this.eventData.bloom_shipping_label_title || 'Pre-paid Overnight Shipping Label'}</div>
                <div class="shipping-kit-description">${message}</div>
                <a href="#shipping-label-info-modal" class="link learn-more open-shipping-label-info">Learn More</a>
              </div>
              <div class="shipping-kit-actions">
                <div class="btn add">
                  ADD | $${(product.price / 100).toFixed(0)}
                </div>
                <div class="link remove">Remove</div>
              </div>
            </label>
            <div
              class="shipping-label-product"
              data-price="${product.price}" data-bf-eligible="${product.bf_eligible === true}" data-bf-product-id="${product.id}" data-bf-blocked="${product.bf_blocked !== false}"
            >
              <input
                class="single-option-selector"
                type="hidden"
                data-name="items[4][id]"
                value="${product.variant_id}"
              >
              <input
                type="hidden"
                data-name="items[4][properties[_bundle_item]]"
                value="related_multiple"
              >
              <input
                type="hidden"
                data-name="items[4][properties[_bundle_id]]"
              >
              <input
                type="hidden"
                data-name="items[4][quantity]"
                value="1"
              >
            </div>
          </div>
        `;
        
        // Control (template test): when test formatting is OFF, restore the original flat
        // shipping-label card so the control PDP matches the live (master) layout. The new
        // .shipping-kit card built above is the redesigned VARIANT only. (Overwrites rather
        // than branches the assignment above so the variant markup is never touched.)
        if (!(this.builder && this.builder.dataset.testFormatting == 'true')) {
          this.locationResults.innerHTML = `
          <div style="text-align: center; font-style: italic; margin-bottom: 1rem;">
            <div style="font-size: 16px !important; margin-bottom: 8px;">${basedOnText}</div>
            <div style="font-size: 16px !important;">${message}</div>
          </div>
          <div class="swatch shipping-label-swatch" style="display: block; position: relative; z-index: 1;">
            <input
              type="checkbox"
              name="shipping_label"
              id="dynamic-shipping-label"
              value="shipping_label_product"
              data-label="Shipping Label"
              aria-label="Shipping Label"
              style="z-index: 1;"
            >
            <label
              for="dynamic-shipping-label"
              class="scheme-border-box animation"
            >
              <div class="flex align-items-center" style="padding-left: 1rem;">
                <img
                  src="${product.image_url || 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTMwIDUwYzExLjA0NiAwIDIwLTguOTU0IDIwLTIwcy04Ljk1NC0yMC0yMC0yMFMxMCAxOC45NTQgMTAgMzBzOC45NTQgMjAgMjAgMjAiIHN0cm9rZT0iIzMzMyIgc3Ryb2tlLXdpZHRoPSIyIi8+PC9zdmc+'}"
                  alt="Shipping Label"
                  width="40"
                  height="30"
                  style="margin-right: 1rem; object-fit: contain;"
                >
                <div class="flex-1">
                  <div style="font-weight: bold; margin-bottom: 4px;">${this.eventData.bloom_shipping_label_title || 'Shipping Label'}</div>
                  <p style="margin: 0; font-size: 14px;"><a href="#shipping-label-info-modal" class="open-shipping-label-info">Learn more</a></p>
                </div>
                <div class="btn add smaller">
                  ADD | $${(product.price / 100).toFixed(0)}
                </div>
                <div class="link remove">Remove</div>
              </div>
            </label>
            <div
              class="shipping-label-product"
              data-price="${product.price}" data-bf-eligible="${product.bf_eligible === true}" data-bf-product-id="${product.id}" data-bf-blocked="${product.bf_blocked !== false}"
            >
              <input
                class="single-option-selector"
                type="hidden"
                data-name="items[4][id]"
                value="${product.variant_id}"
              >
              <input
                type="hidden"
                data-name="items[4][properties[_bundle_item]]"
                value="related_multiple"
              >
              <input
                type="hidden"
                data-name="items[4][properties[_bundle_id]]"
              >
              <input
                type="hidden"
                data-name="items[4][quantity]"
                value="1"
              >
            </div>
          </div>
        `;
        }

        // Add event listener to the dynamic shipping label checkbox
        const shippingCheckbox = this.locationResults.querySelector('#dynamic-shipping-label');
        const shippingInputs = this.locationResults.querySelectorAll('.shipping-label-product input[type="hidden"]');
        const learnMoreLink = this.locationResults.querySelector('.open-shipping-label-info');
        
        if (shippingCheckbox) {
          shippingCheckbox.addEventListener('change', (e) => {
            if (e.target.checked) {
              // Activate hidden inputs by setting name attribute
              shippingInputs.forEach((input) => {
                if (input.dataset.name) {
                  input.setAttribute('name', input.dataset.name);
                }
              });
            } else {
              // Deactivate hidden inputs by removing name attribute
              shippingInputs.forEach((input) => {
                input.removeAttribute('name');
              });
            }
          });
        }
        
        // Add event listener for Learn more link
        if (learnMoreLink) {
          learnMoreLink.addEventListener('click', (e) => {
            e.preventDefault();
            // For now, we'll use a placeholder modal - you can update this later
            const modalHTML = `
              <div style="padding: 4rem 2rem; max-width: 500px; background-color: white;">
                <h2 style="margin: 0 0 1rem; font-size: 24px; text-align: center;">Overnight prepaid shipping label</h2>
                <p style="font-size: 16px; line-height: 1.6; margin: 1rem 0;">
                  Our overnight shipping label provides discounted rates for you to package and ship your flowers on your own.
                </p>
                <p style="font-size: 16px; line-height: 1.6; margin: 1rem 0;">
                  You will receive the label via email within 24 hours of purchase.
                </p>
                <p style="font-size: 16px; line-height: 1.6; margin: 1rem 0;">
                  The email will have the subject line <span><strong>“Your Return Shipping Label.”</strong></span> A link to detailed shipping instructions will be included in that email.
                </p>
              </div>
            `;
            $s.openModal(modalHTML, 'shipping-label-info');
          });
        }
        
        // Add event listener for the Instructions link
        const instructionsLink = this.locationResults.querySelector('a[href="#open-info-modal"]');
        if (instructionsLink) {
          instructionsLink.addEventListener('click', (e) => {
            e.preventDefault();
            this.handleLinkClick(e);
          });
        }
      }

      showRecreationOptions() {
        const message = this.eventData.blooms_box_unavailable_recreation_message;
        this.locationResults.innerHTML = `
          <div class="shipping-recommendation">
            <div>${message}</div>
          </div>
        `;
        this.locationResults.style.display = 'block';
        this.locationResultsTitle.style.display = 'block';
        // Hide any existing bloom box elements when showing recreation options
        const bloomBoxSwatch = this.querySelector('.swatch:not(.shipping-label-swatch)');
        if (bloomBoxSwatch) {
          bloomBoxSwatch.style.display = 'none';
        }
        
        const shippingLabelSwatch = this.querySelector('.shipping-label-swatch');
        if (shippingLabelSwatch) {
          shippingLabelSwatch.style.display = 'none';
        }
        
        const swatchGroup = this.querySelector('.swatch-group');
        if (swatchGroup) {
          swatchGroup.style.display = 'none';
        }
        
        // Force hide the zip code message when showing recreation options
        if (this.messageBlooms) {
          this.messageBlooms.style.display = 'none';
        }
      }

      hideShippingOptions() {
        if (this.locationResults) {
          this.locationResults.style.display = 'none';
          this.locationResultsTitle.style.display = 'none';
          this.locationResults.innerHTML = '';
        }
      }

      onLocationResultsClick(e) {
        if (e.target.classList.contains('add-bloom-box')) {
          e.preventDefault();
          const productType = e.target.dataset.productType;
          this.addBloomBoxProduct(productType, e.target);
        } else if (e.target.classList.contains('add-shipping-label')) {
          e.preventDefault();
          this.addShippingLabelProduct(e.target);
        }
      }

      addBloomBoxProduct(productType, buttonElement) {
        // Clear existing selections
        this.clearAllSelections();
        
        // Get product data based on type
        const productData = productType === 'pickup' 
          ? this.eventData.pickup_bloom_product 
          : this.eventData.regular_bloom_product;
        
        if (!productData || !productData.variant_id) {
          console.error('Product data not available for type:', productType);
          return;
        }

        // Find and update the bloom box inputs
        const bloomInputs = this.querySelectorAll('.bloom-product input[type="hidden"]');
        bloomInputs.forEach((input) => {
          if (input.dataset.name && input.dataset.name.includes('[id]')) {
            input.value = productData.variant_id;
            input.setAttribute('name', input.dataset.name);
          } else if (input.dataset.name) {
            input.setAttribute('name', input.dataset.name);
          }
        });

        // Add preview image URL property for pickup products to show correct image in cart
        if (productType === 'pickup' && productData.image) {
          const form = this.closest('form') || document.querySelector('form[action*="/cart/add"]');
          if (form) {
            // Remove existing preview image input if it exists
            let existingInput = form.querySelector('input[name="properties[_preview_image_url]"]');
            if (existingInput) {
              existingInput.remove();
            }
            
            // Add new preview image input
            const hiddenInput = document.createElement('input');
            hiddenInput.type = 'hidden';
            hiddenInput.name = 'properties[_preview_image_url]';
            hiddenInput.value = productData.image;
            form.appendChild(hiddenInput);
          }
        }

        // Check the bloom box checkbox
        const bloomCheckbox = this.querySelector('[name="bloom_box"]');
        if (bloomCheckbox) {
          bloomCheckbox.checked = true;
          bloomCheckbox.disabled = false;
        }

        // Update UI feedback
        if (buttonElement) {
          buttonElement.textContent = 'ADDED';
          buttonElement.classList.add('added');
        }
        
        // Trigger bundle change event
        if (this.builder) {
          this.builder.dispatchEvent(new CustomEvent('bundleChange', {detail: {}}));
        }
      }

      addShippingLabelProduct(buttonElement) {
        // Clear existing selections
        this.clearAllSelections();

        // Enable shipping label
        const shippingLabelCheckbox = this.querySelector('[name="shipping_label"]');
        if (shippingLabelCheckbox) {
          shippingLabelCheckbox.checked = true;
        }

        // Enable shipping label product inputs
        const shippingLabelInputs = this.querySelectorAll('.shipping-label-product input[type="hidden"]');
        shippingLabelInputs.forEach((input) => {
          if (input.dataset.name) {
            input.setAttribute('name', input.dataset.name);
          }
        });

        // Update UI feedback
        if (buttonElement) {
          buttonElement.textContent = 'ADDED';
          buttonElement.classList.add('added');
        }
        
        // Trigger bundle change event
        if (this.builder) {
          this.builder.dispatchEvent(new CustomEvent('bundleChange', {detail: {}}));
        }
      }

      clearAllSelections() {
        // Clear bloom box selections
        const bloomCheckbox = this.querySelector('[name="bloom_box"]');
        if (bloomCheckbox) {
          bloomCheckbox.checked = false;
        }
        
        const bloomInputs = this.querySelectorAll('.bloom-product input[type="hidden"]');
        bloomInputs.forEach((input) => {
          input.removeAttribute('name');
        });

        // Clear shipping label selections  
        const shippingLabelCheckbox = this.querySelector('[name="shipping_label"]');
        if (shippingLabelCheckbox) {
          shippingLabelCheckbox.checked = false;
        }
        
        const shippingLabelInputs = this.querySelectorAll('.shipping-label-product input[type="hidden"]');
        shippingLabelInputs.forEach((input) => {
          input.removeAttribute('name');
        });

        // Reset button states
        this.querySelectorAll('.add-bloom-box, .add-shipping-label').forEach(btn => {
          btn.textContent = 'ADD';
          btn.classList.remove('added');
        });
      }

      disableZipCodeInput() {
        if (!this.zipCodeInput) return;
        
        this.zipCodeInput.disabled = true;
        this.zipCodeInput.style.backgroundColor = '#f8f9fa';
        this.zipCodeInput.style.cursor = 'not-allowed';
        this.zipCodeInput.style.opacity = '0.6';
        this.zipCodeInput.placeholder = 'Please select an event date first';
        
        // Clear any existing shipping options
        this.hideShippingOptions();
        this.zipCodeEntered = false;
      }

      enableZipCodeInput() {
        if (!this.zipCodeInput) return;
        
        this.zipCodeInput.disabled = false;
        this.zipCodeInput.style.backgroundColor = 'white';
        this.zipCodeInput.style.cursor = 'text';
        this.zipCodeInput.style.opacity = '1';
        this.zipCodeInput.style.pointerEvents = 'auto';
        this.zipCodeInput.style.userSelect = 'text';
        this.zipCodeInput.placeholder = 'Enter zip code';
        this.zipCodeInput.tabIndex = 0;
      }

      hideZipCodeInput() {
        const zipSection = this.querySelector('.zip-code-section');
        if (zipSection) {
          zipSection.style.setProperty('display', 'none', 'important');
        }
      }

      showZipCodeInput() {
        const zipSection = this.querySelector('.zip-code-section');
        if (zipSection) {
          zipSection.style.display = 'block';
          
          // Set up search button listener when zip section becomes visible
          const searchBtn = this.querySelector('.zip-search-btn');
          if (searchBtn) {
            searchBtn.addEventListener('click', (e) => {
              e.preventDefault();
              this.onZipCodeSearch(e);
            });
          }
        }
      }
  
      handleTournAroundMessage(date) {
        const monthIndex = date.getMonth();
        const monthTurnarounds = this.monthlyTurnaroundsMap[monthIndex];
  
        if (monthTurnarounds) {
            const message = lngg.product_main__builder__builder_event_message + ' ' + monthTurnarounds;
            this.messageTurnaround.innerHTML = message;
            this.messageInput.value = message;
            this.messageTurnaround.style.display = 'block';
            return;
        }
  
        this.messageTurnaround.style.display = 'none';
      }
  
      handleBloomsBoxMessage(selectedDate) {
        // New logic: Don't show automatic shipping recommendations based on event date
        // Only show the base message asking for zip code if no zip code is entered
        
        const diffDays = this.daysUntil(selectedDate);
        
        // For future events (3+ days), don't show zip code message at all
        if (diffDays >= 3) {
          if (this.messageBlooms) {
            this.messageBlooms.style.display = 'none';
          }
          return;
        }
        
        if (!this.zipCodeEntered) {
          // Show basic message asking for zip code (only for near-term events)
          const baseMessage = "Please enter your zip code above to see shipping recommendations.";
          
          if (this.messageBlooms) {
            this.messageBlooms.innerHTML = baseMessage;
            this.messageBlooms.style.display = 'block';
          }
          
          // Hide all shipping options
          this.hideShippingOptions();
          
          // Hide the old bloom box swatch
          const bloomBoxSwatch = this.querySelector('.swatch');
          if (bloomBoxSwatch) {
            bloomBoxSwatch.style.display = 'none';
          }
          
          // Hide shipping label swatch initially
          const shippingLabelSwatch = document.querySelector('.shipping-label-swatch');
          if (shippingLabelSwatch) {
            shippingLabelSwatch.style.display = 'none';
          }
        } else {
          // Zip code is entered, hide the base message
          if (this.messageBlooms) {
            this.messageBlooms.style.display = 'none';
          }
        }
        
      }

      handleLinkClick(e) {
        const href = new URL(e.target.href);
        if(href.hash){
          e.preventDefault();
          if(href.hash == '#open-info-modal'){
            // First try to find the modal template
            const modalTemplate = document.querySelector('#shipping-instructions-modal') || this.closest('event-builder').querySelector('#shipping-instructions-modal');
            if(modalTemplate) {
              const shippingModal = modalTemplate.innerHTML;
              $s.openModal(shippingModal, 'event-modal');
              return;
            }
            
            // Fallback: use step info system for shipping instructions (step 8)
            if(this.builder && this.builder.stepsInfoData) {
              const shippingStepInfo = this.builder.stepsInfoData.find(step => step.step_number == 8);
              if(shippingStepInfo) {
                this.builder.openInfoModal(8);
                return;
              }
            }
            
            // Final fallback: try to get step from closest step element
            const stepElement = e.target.closest('.step');
            if(stepElement && stepElement.dataset.step) {
              const stepNumber = stepElement.dataset.step/1;
              const stepInfo = this.builder.stepsInfoData.find(step => step.step_number == stepNumber);
              if(stepInfo) {
                this.builder.openInfoModal(stepInfo.step_number);
              }
            }
          }
        }
      }

      handleEventBloomsBoxMessage(selectedDate) {
        const diffDays = this.daysUntil(selectedDate);
        const messages = this.bloomsBoxAvailabilityMap;

        this.bloomsBoxAvailabilityMap.sort((a, b) => a.days - b.days);
        let selectedMessage = null;
  
        for (let i = 0; i < messages.length; i++) {
          if (diffDays >= messages[i].days) {
            selectedMessage = messages[i];
          } else {
            break;
          }
        }

        if (selectedMessage) {
          document.querySelector(".custom-card-event").style.display = "block";
          document.querySelector(".custom-card-event .event-title").innerHTML = selectedMessage.title;
          document.querySelector(".custom-card-event .event-message").innerHTML = selectedMessage.message;
          if(selectedMessage.days >= 2){
            document.querySelector(".custom-card-event .bloom-box-link").style.display = "block";
            const shippingLabelSwatch = document.querySelector(".shipping-label-swatch");
            if(shippingLabelSwatch) shippingLabelSwatch.style.display = "none";
          } else {
            document.querySelector(".custom-card-event .bloom-box-link").style.display = "none";
            const shippingLabelSwatch = document.querySelector(".shipping-label-swatch");
            if(shippingLabelSwatch) shippingLabelSwatch.style.display = "block";
          }
          return;
        }
  
      }
  
      daysUntil(targetDate) {
        const target = new Date(targetDate);
        const now = new Date();
  
        target.setHours(now.getHours(), now.getMinutes(), now.getSeconds(), now.getMilliseconds());
  
        const differenceInMs = target - now;
        const daysDifference = differenceInMs / (1000 * 60 * 60 * 24);
  
        return Math.abs(daysDifference) < 1e-6 ? 0 : daysDifference;
      }
  
    }
    customElements.define('event-builder', EventBuilder);

    // Cart pickup modal using theme's modal system
    window.showCartPickupModal = async function(locationId) {
      try {
        const response = await fetch(`https://pf-shopify-locations-api.netlify.app/.netlify/functions/locations?id=${locationId}`);
        const data = await response.json();
        const location = data.location;
        
        const modalHTML = `
          <div class="pickup-location-details" style="text-align: center; padding: 2rem; max-width: 500px;">
            <h2 style="margin-bottom: 1.5rem;">${location.name}</h2>
            
            <div id="cart-pickup-map" style="height: 200px; width: 100%; margin-bottom: 1.5rem; border: 1px solid #ddd; border-radius: 4px;"></div>
            
            <div style="margin-bottom: 1rem; text-align: center;">
              <strong style="display: block; margin-bottom: 3px;">Address:</strong>
              <div>${location.address?.address_line_1 || ''}</div>
              ${location.address?.address2 ? `<div>${location.address.address2}</div>` : ''}
              <div>${location.address?.city || ''}, ${location.address?.province || ''} ${location.address?.zip || ''}</div>
            </div>
            
            ${location.phone && location.phone !== 'Not available' ? `
              <div style="margin-bottom: 1rem;">
                <strong>Phone:</strong> ${location.phone}
              </div>
            ` : ''}
            
            ${location.hours ? `
              <div>
                <strong>Hours:</strong><br>
                <div style="font-size: 14px; line-height: 1.4; margin-top: 0.5rem;">
                  ${Object.entries(location.hours).map(([day, hours]) => 
                    `<div><strong>${day}:</strong> ${hours}</div>`
                  ).join('')}
                </div>
                <p style="font-style: italic; color: #666; font-size: 12px; margin-top: 1rem;">Hours do not account for holiday exceptions.</p>
              </div>
            ` : ''}
          </div>
        `;
        
        $s.openModal(modalHTML, 'pickup-location-info');
        
        // Initialize map after modal is shown
        setTimeout(() => {
          initCartPickupMap(location.address?.latitude, location.address?.longitude, location.name);
        }, 100);
        
      } catch (error) {
        $s.openModal('<div style="text-align: center; padding: 2rem;">Unable to load location details. Please try again.</div>', 'pickup-location-info');
      }
    };

    // Map function for cart modal
    window.initCartPickupMap = function(lat, lng, locationName) {
      const mapContainer = document.getElementById('cart-pickup-map');
      if (!mapContainer || !lat || !lng) {
        mapContainer.innerHTML = '<div style="color: #999; display: flex; align-items: center; justify-content: center; height: 100%;">Map not available</div>';
        return;
      }

      // Load Leaflet if needed
      if (!window.L) {
        const leafletCSS = document.createElement('link');
        leafletCSS.rel = 'stylesheet';
        leafletCSS.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
        document.head.appendChild(leafletCSS);
        
        const leafletJS = document.createElement('script');
        leafletJS.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
        leafletJS.onload = function() {
          createCartMap(lat, lng, locationName);
        };
        document.head.appendChild(leafletJS);
      } else {
        createCartMap(lat, lng, locationName);
      }
      
      function createCartMap(lat, lng, name) {
        const map = L.map('cart-pickup-map').setView([lat, lng], 15);
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          attribution: '© OpenStreetMap contributors'
        }).addTo(map);
        L.marker([lat, lng]).addTo(map);
      }
    };

    // Global function for pickup location modal
    window.openPickupLocationModal = async function(event, locationId) {
      if (event) {
        event.preventDefault();
      }
      
      try {
        // Get user's coordinates from the current zip code lookup
        let userCoords = '';
        const eventBuilder = document.querySelector('event-builder');
        if (eventBuilder && eventBuilder.currentZipCode) {
          // Get coordinates from the stored zip code
          try {
            const zipResponse = await fetch(`https://api.zippopotam.us/us/${eventBuilder.currentZipCode}`);
            if (zipResponse.ok) {
              const zipData = await zipResponse.json();
              const userLat = zipData.places[0].latitude;
              const userLng = zipData.places[0].longitude;
              userCoords = `&lat=${userLat}&lng=${userLng}`;
            }
          } catch (error) {
            console.log('Could not get user coordinates for modal');
          }
        }
        
        // Get location details from server with user coordinates for distance calculation
        const response = await fetch(`https://pf-shopify-locations-api.netlify.app/.netlify/functions/locations?id=${locationId}${userCoords}`);
        const data = await response.json();
        
        if (!data.success || !data.location) {
          console.error('Failed to load location details:', data);
          return;
        }
        
        const location = data.location;
        
        // Create modal HTML
        const modalHTML = `
          <div id="pickup-location-modal" onclick="if(event.target === this) { closePickupLocationModal(event); }" style="
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.5);
            z-index: 10000;
            display: flex;
            align-items: center;
            justify-content: center;
          ">
            <div style="
              background: #ffffff !important;
              background-color: #ffffff !important;
              border-radius: 8px;
              max-width: 500px;
              width: 90%;
              max-height: 80vh;
              overflow-y: auto;
              position: relative;
              opacity: 1 !important;
              box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3) !important;
              border: 1px solid #ddd !important;
            ">
              <button onclick="closePickupLocationModal(event)" style="
                position: absolute;
                top: 15px;
                right: 15px;
                background: none;
                border: none;
                font-size: 24px;
                cursor: pointer;
                color: #666;
              ">&times;</button>
              
              <div style="padding: 30px 30px 20px;">
                <h2 style="margin: 0 0 10px; font-size: 22px; text-align: center;">${location.name}</h2>
                <p style="margin: 0 0 20px; text-align: center; color: #666; font-size: 18px;">${location.distance} away</p>
                
                <div id="pickup-location-map" style="
                  width: 100%;
                  height: 200px;
                  background: #f0f0f0;
                  border-radius: 4px;
                  margin-bottom: 20px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  color: #666;
                ">
                  Loading map...
                </div>
                
                <div style="text-align: center; margin-bottom: 15px;">
                  <p style="font-size: 18px;">${location.address?.address_line_1 || ''}, ${location.address?.city || ''}, ${location.address?.province || ''} ${location.address?.zip || ''}
                </div>
                
                ${location.phone && location.phone !== 'Not available' ? `
                <div style="text-align: center; margin-bottom: 20px;">
                  <strong>Phone:</strong> ${location.phone}
                </div>
                ` : ''}
                
                ${location.hours ? `
                <div style="margin-bottom: 20px;">
                  <strong style="display: block; margin-bottom: 10px;">Hours:</strong>
                  <div style="font-size: 14px; line-height: 1.4;">
                    ${Object.entries(location.hours).map(([day, hours]) => 
                      `<div><strong>${day}:</strong> ${hours}</div>`
                    ).join('')}
                  </div>
                </div>
                  <p style="font-style: italic; color: #666; font-size: 12px; margin: 0; text-align: center;">Hours do not account for holiday exceptions.</p>
                ` : ''}
              </div>
            </div>
          </div>
        `;
        
        // Add modal to page
        document.body.insertAdjacentHTML('beforeend', modalHTML);
        
        // Initialize map
        initPickupLocationMap(location.address?.latitude, location.address?.longitude, location.name);
        
      } catch (error) {
        console.error('Error opening pickup location modal:', error);
      }
    };
    
    window.closePickupLocationModal = function(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
      }
      
      // Re-enable cart interactions
      const cart = document.getElementById('side-cart');
      if (cart) {
        cart.style.pointerEvents = 'auto';
      }
      
      const modal = document.getElementById('pickup-location-modal');
      if (modal) {
        modal.remove();
      }
    };
    
    window.initPickupLocationMap = function(lat, lng, locationName) {
      const mapContainer = document.getElementById('pickup-location-map');
      if (!mapContainer || !lat || !lng) {
        mapContainer.innerHTML = '<div style="color: #999;">Map not available</div>';
        return;
      }
      
      // Load Leaflet CSS and JS if not already loaded
      if (!window.L) {
        const leafletCSS = document.createElement('link');
        leafletCSS.rel = 'stylesheet';
        leafletCSS.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
        document.head.appendChild(leafletCSS);
        
        const leafletJS = document.createElement('script');
        leafletJS.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
        leafletJS.onload = function() {
          createMap(lat, lng, locationName);
        };
        document.head.appendChild(leafletJS);
      } else {
        createMap(lat, lng, locationName);
      }
      
      function createMap(lat, lng, name) {
        const map = L.map('pickup-location-map').setView([lat, lng], 15);
        
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          attribution: '© OpenStreetMap contributors'
        }).addTo(map);
        
        L.marker([lat, lng])
          .addTo(map)
      }
    };
    
    // Close modal when clicking outside
    document.addEventListener('click', function(event) {
      const modal = document.getElementById('pickup-location-modal');
      if (modal && event.target === modal) {
        event.preventDefault();
        event.stopPropagation();
        closePickupLocationModal(event);
      }
    });
  }
